(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function syncNavPanel(toggle, headerTop, open) {
    const shouldOpen = open && MOBILE_QUERY.matches;
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    headerTop.classList.toggle('is-nav-open', shouldOpen);
  }

  function initBlogCenterNav(root) {
    const toggle = root.querySelector('[data-blog-center-nav-toggle]');
    const headerTop = root.querySelector('[data-blog-center-header-top]');
    if (!toggle || !headerTop) return;

    const onToggleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      syncNavPanel(toggle, headerTop, !isOpen);
    };

    const onDocumentClick = (event) => {
      if (!MOBILE_QUERY.matches) return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (headerTop.contains(event.target)) return;
      syncNavPanel(toggle, headerTop, false);
    };

    const onBreakpointChange = () => {
      syncNavPanel(toggle, headerTop, false);
    };

    toggle.addEventListener('click', onToggleClick);
    document.addEventListener('click', onDocumentClick);
    MOBILE_QUERY.addEventListener('change', onBreakpointChange);
    onBreakpointChange();
  }

  function getFocusable(container) {
    return Array.from(
      container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true');
  }

  function openNewsletterModal(root) {
    const modal = root.querySelector('[data-newsletter-success-modal]');
    if (!modal) return;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    const dialog = modal.querySelector('.cs-blog-center-newsletter-modal__dialog');
    const closeBtn = modal.querySelector('[data-newsletter-modal-close]');
    (dialog || closeBtn)?.focus();
  }

  function closeNewsletterModal(root) {
    const modal = root.querySelector('[data-newsletter-success-modal]');
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    const emailInput = root.querySelector('.cs-blog-center-newsletter__input');
    emailInput?.focus();
  }

  function setSubmitting(form, isSubmitting) {
    const button = form.querySelector('[data-newsletter-submit]');
    if (!button) return;
    button.disabled = isSubmitting;
    button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
  }

  function showFormError(form, message) {
    let errorEl = form.querySelector('.cs-blog-center-newsletter__message--error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'cs-blog-center-newsletter__message cs-blog-center-newsletter__message--error';
      errorEl.setAttribute('role', 'alert');
      form.appendChild(errorEl);
    }
    errorEl.textContent = message;
  }

  function clearFormError(form) {
    const errorEl = form.querySelector('.cs-blog-center-newsletter__message--error');
    if (errorEl) errorEl.remove();
  }

  function resetFormFields(form) {
    const emailInput = form.querySelector('.cs-blog-center-newsletter__input');
    if (emailInput) emailInput.value = '';

    form.querySelectorAll('.cs-blog-center-newsletter__checkbox-input').forEach((input) => {
      input.checked = true;
    });
  }

  function getNativeSubmit(form) {
    return HTMLFormElement.prototype.submit.bind(form);
  }

  function submitNewsletter(form, root) {
    clearFormError(form);

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const frame = root.querySelector('[data-newsletter-frame]');
    if (!frame) {
      showFormError(form, 'Something went wrong. Please try again.');
      return;
    }

    if (form.dataset.newsletterSubmitting === 'true') return;

    form.dataset.newsletterSubmitting = 'true';
    frame.dataset.newsletterPending = 'true';
    setSubmitting(form, true);

    const timeoutId = window.setTimeout(() => {
      delete form.dataset.newsletterSubmitting;
      delete frame.dataset.newsletterPending;
      setSubmitting(form, false);
      showFormError(form, 'Something went wrong. Please try again.');
    }, 15000);

    frame.dataset.newsletterTimeout = String(timeoutId);

    try {
      getNativeSubmit(form)();
    } catch (error) {
      window.clearTimeout(timeoutId);
      delete form.dataset.newsletterSubmitting;
      delete frame.dataset.newsletterPending;
      setSubmitting(form, false);
      showFormError(form, 'Something went wrong. Please try again.');
    }
  }

  function handleNewsletterFrameLoad(form, root) {
    const frame = root.querySelector('[data-newsletter-frame]');
    if (!frame || frame.dataset.newsletterPending !== 'true') return;

    window.clearTimeout(Number(frame.dataset.newsletterTimeout));
    delete form.dataset.newsletterSubmitting;
    delete frame.dataset.newsletterPending;
    delete frame.dataset.newsletterTimeout;
    setSubmitting(form, false);
    resetFormFields(form);
    openNewsletterModal(root);
  }

  function initNewsletter(root) {
    if (root.dataset.newsletterReady === 'true') return;
    root.dataset.newsletterReady = 'true';

    const form = root.querySelector('.cs-blog-center-newsletter__form');
    const modal = root.querySelector('[data-newsletter-success-modal]');
    if (!form || !modal) return;

    const frame = root.querySelector('[data-newsletter-frame]');
    if (!frame) return;

    // Once JS is active, submit natively into a hidden iframe so the page never navigates.
    form.setAttribute('target', frame.name);
    const submitButton = form.querySelector('.cs-blog-center-newsletter__button');
    if (submitButton) {
      submitButton.type = 'button';
      submitButton.setAttribute('data-newsletter-submit', '');
    }

    if (root.querySelector('[data-newsletter-posted-success]')) {
      openNewsletterModal(root);
    }

    modal.querySelectorAll('[data-newsletter-modal-close]').forEach((el) => {
      el.addEventListener('click', () => closeNewsletterModal(root));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || modal.hidden) return;
      closeNewsletterModal(root);
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || modal.hidden) return;
      const dialog = modal.querySelector('.cs-blog-center-newsletter-modal__dialog');
      if (!dialog) return;
      const focusable = getFocusable(dialog);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    frame.addEventListener('load', () => handleNewsletterFrameLoad(form, root));

    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        submitNewsletter(form, root);
      },
      true
    );

    if (submitButton) {
      submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        submitNewsletter(form, root);
      });
    }

    form.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (event.target && event.target.tagName === 'TEXTAREA') return;
      event.preventDefault();
      submitNewsletter(form, root);
    });
  }

  function boot() {
    document.querySelectorAll('.cs-blog-center').forEach(initBlogCenterNav);
    document.querySelectorAll('[data-blog-center-newsletter]').forEach(initNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
